import { render, staticRenderFns } from "./RealtimeApp.vue?vue&type=template&id=3ee0cbdc&scoped=true"
import script from "./RealtimeApp.vue?vue&type=script&lang=js"
export * from "./RealtimeApp.vue?vue&type=script&lang=js"
import style0 from "./RealtimeApp.vue?vue&type=style&index=0&id=3ee0cbdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee0cbdc",
  null
  
)

export default component.exports